export default "__VITE_ASSET__CZnhi$m5__"